<div
    [attr.data-testid]="settings.id"
    class="grid auto-cols-max grid-flow-col w-full gap-2 grid-rows-1"
>
    <ng-container *ngIf="inputControl$ | async"></ng-container>

    <ng-container *ngFor="let tab of settings?.tabs">
        <div
            [attr.data-testid]="settings.id + '-' + tab?.value + '-container'"
            [attr.data-styleTarget]="
                tab.id ? tab.id : settings.id + '-' + tab?.value + '-container'
            "
            [attr.data-styleSelected]="tab?.value === selectedValue"
            [attr.data-styleDisabled]="tab?.disabled"
            [attr.data-uiType]="'tab'"
            class="rounded-sm px-2 py-1 font-overline text-center cursor-pointer"
            (click)="tabClick(tab)"
            [ngClass]="{
                'bg-dat-blue-050': tab?.value === selectedValue,
                'text-dat-blue-700': tab?.value === selectedValue,
                'bg-dat-grey-050': tab?.value !== selectedValue,
                'text-dat-grey-900': tab?.value !== selectedValue
            }"
        >
            <span
                [attr.data-testid]="settings.id + '-' + tab?.value + '-label'"
            >
                {{ tab.display }}</span
            >
        </div>
        <ng-container *ngIf="tab.seperator">
            <div class="font-light-headline">|</div>
        </ng-container>
    </ng-container>
</div>
